module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require('../assets/logo.png')
    },
    on: {
      "click": _vm.toIndex
    }
  }), _c('img', {
    staticClass: "menu",
    attrs: {
      "src": require('../assets/menu.png')
    },
    on: {
      "click": _vm.show
    }
  }), _vm._t("default"), _c('transition', {
    attrs: {
      "name": "right-slide"
    }
  }, [(_vm.showRight) ? _c('rightbar', {
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-571f8f58","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 512
// module chunks = 1